import * as React from "react"
import { SVGProps } from "react"

const SvgAttachemail = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
        <path d="M22 20.85 5 10v23h25v3H5.15q-1.25 0-2.2-.925Q2 34.15 2 33V7q0-1.15.9-2.075Q3.8 4 5 4h34q1.15 0 2.075.925Q42 5.85 42 7v12h-3v-9Zm0-3.2L39 7H5ZM39.6 44q-2.8 0-4.7-2-1.9-2-1.9-4.8V26q0-1.65 1.175-2.825Q35.35 22 37.05 22q1.65 0 2.8 1.175T41 26v11.5h-3V25.85q0-.55-.225-.975-.225-.425-.725-.425t-.775.425Q36 25.3 36 25.85V37.3q0 1.65 1 2.9t2.6 1.25q1.5 0 2.45-1.175Q43 39.1 43 37.5v-9.85h3v9.85q0 2.7-1.85 4.6Q42.3 44 39.6 44ZM5 10V7v26-12.5Z" />
  </svg>
)

export default SvgAttachemail
